import Paper from '@mui/material/Paper';

export const CustomPaper = ({ width, elevation, margin, ...props }) => {
  return <Paper {...props} style={{ width, margin, ...props.style }} elevation={elevation} />;
};
